import type { ApplicationInsights } from "@microsoft/applicationinsights-web";

/**
 * Registers telemetry filters to reduce noise in Application Insights.
 * Excludes: PostHog, Google Analytics, icon requests, LinkedIn ads, jsdelivr, self-hosted emoji data, ResizeObserver exceptions.
 */
export function addTelemetryFilters(appInsights: ApplicationInsights): void {
  appInsights.addTelemetryInitializer(envelope => {
    if (shouldDropRemoteDependency(envelope)) return false;
    if (shouldDropException(envelope)) return false;
  });
}

function shouldDropRemoteDependency(envelope: { baseType?: string; baseData?: { target?: string } }): boolean {
  if (envelope?.baseType !== "RemoteDependencyData") return false;
  const target = envelope.baseData?.target;
  if (!target) return false;
  if (target.includes("posthog.com")) return true;
  if (target.includes("analytics.google.com")) return true;
  if (target.includes("/icons/")) return true;
  if (target.includes("ads.linkedin.com")) return true;
  if (target.includes("jsdelivr.net")) return true;
  if (target.includes("/images/emoji/data.json")) return true;
  return false;
}

function shouldDropException(envelope: { baseType?: string; baseData?: { exceptions?: Array<{ message?: string }> } }): boolean {
  if (envelope?.baseType !== "ExceptionData") return false;
  const msg = envelope.baseData?.exceptions?.[0]?.message ?? "";
  if (msg.includes("ResizeObserver")) return true;
  return false;
}
